<div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <h2 class="card-title">
      <!-- {{ data.title }} -->
      Add/Edit Screen
    </h2>
    <span class="justify-content-end">
      <button class="btn" style="font-size: 25px" (click)="closeModal()">
        &times;
      </button>
    </span>
  </div>
  <div class="card-body">
    <!-- <div class="card-text"> -->
    <form [formGroup]="form">
      <div class="position-relative row form-group">
        <label class="col-sm-12 col-form-label"
          >{{ "Form.NAME" | translate }}
          <span style="color: red !important">*</span>
        </label>
        <div class="col-sm-12">
          <input
            formControlName="name"
            style="border-radius: 10px !important; padding: 10px !important"
            class="w-100"
          />

          <div
            *ngIf="form.get('name')?.invalid && form.get('name')?.touched"
            class="invalid-label"
          >
            {{ "Form.Error.NAME" | translate }}
          </div>
        </div>
      </div>
      <div class="position-relative row form-group">
        <label
          class="col-sm-12 col-form-label"
          [ngClass]="{
            'invalid-label':
              form.get('url')?.invalid && form.get('url')?.touched
          }"
          >{{ "Form.URL" | translate }}
          <span style="color: red !important">*</span>
        </label>
        <div class="col-sm-12">
          <input
            formControlName="url"
            style="border-radius: 10px !important; padding: 10px !important"
            class="w-100"
          />
          <div
            *ngIf="form.get('url')?.invalid && form.get('url')?.touched"
            class="invalid-label"
          >
            {{ "Form.Error.URL" | translate }}
          </div>
        </div>
      </div>
      <div class="position-relative row form-group">
        <label
          class="col-sm-12 col-form-label"
          [ngClass]="{
            'invalid-label':
              form.get('description')?.invalid &&
              form.get('description')?.touched
          }"
          >{{ "Form.DESCRIPTION" | translate }}</label
        >
        <div class="col-sm-12">
          <input
            formControlName="description"
            style="border-radius: 10px !important; padding: 10px !important"
            class="w-100"
          />
          <div
            *ngIf="
              form.get('description')?.invalid &&
              form.get('description')?.touched
            "
            class="invalid-label"
          >
            {{ "Form.Error.DESCRIPTION" | translate }}
          </div>
        </div>
      </div>
      <div class="position-relative row form-group">
        <label
          class="col-sm-12 col-form-label"
          [ngClass]="{
            'invalid-label':
              form.get('module')?.invalid && form.get('module')?.touched
          }"
          >{{ "Form.module" | translate }}</label
        >
        <div class="col-sm-12">
          <ng-select
            [items]="moduleList"
            [virtualScroll]="true"
            bindLabel="name"
            bindValue="id"
            formControlName="module"
            placeholder="Module"
          >
          </ng-select>

          <div
            *ngIf="form.get('module')?.invalid && form.get('module')?.touched"
            class="invalid-label"
          >
            {{ "Form.Error.module" | translate }}
          </div>
        </div>
      </div>
      <div class="position-relative row form-group">
        <label
          class="col-sm-12 col-form-label"
          [ngClass]="{
            'invalid-label':
              form.get('displayOrder')?.invalid &&
              form.get('displayOrder')?.touched
          }"
          >{{ "Form.displayOrder" | translate }}
        </label>
        <div class="col-sm-12">
          <input
            type="number"
            formControlName="displayOrder"
            style="border-radius: 10px !important; padding: 10px !important"
          />
          <div
            *ngIf="
              form.get('displayOrder')?.invalid &&
              form.get('displayOrder')?.touched
            "
            class="invalid-label"
          >
            {{ "Form.Error.displayOrder" | translate }}
          </div>
        </div>
      </div>
      <div class="position-relative row form-group">
        <label
          class="col-sm-12 col-form-label"
          [ngClass]="{
            'invalid-label':
              form.get('roles')?.invalid && form.get('roles')?.touched
          }"
          >{{ "Form.Role" | translate }}
        </label>
        <div class="col-sm-12">
          <ng-select
            [items]="roleList"
            [virtualScroll]="true"
            bindLabel="name"
            bindValue="internalname"
            formControlName="roles"
            placeholder="{{ 'Form.Role' | translate }}"
          >
          </ng-select>

          <div
            *ngIf="form.get('roles')?.invalid && form.get('roles')?.touched"
            class="invalid-label"
          >
            {{ "Form.Error.roles" | translate }}
          </div>
        </div>
      </div>

      <div class="d-grid gap-2 d-md-flex justify-content-md-start mt-2 pt-2">
        <button
          class="btn btn-primary btn-lg font-size-lg"
          (click)="onSubmit()"
          type="submit"
          cdkFocusInitial
        >
          {{ "Form.SAVE" | translate }}
        </button>

        <button
          class="btn btn-secondary btn-lg font-size-lg text-white"
          (click)="onNoClick()"
        >
          {{ "Form.CANCEL" | translate }}
        </button>
      </div>
    </form>
    <!-- </div> -->
  </div>
</div>
